import { useState } from "react";
import SkeletonCard from "../skeletons/SkeletonCard";
import { formatCurrency } from "../../utils";
import { ArrowPathIcon } from "@heroicons/react/16/solid";
import { useBotDemo } from "../../context/botDemoContext";

export default function CurrentValueForwardTesting() {
  const [loadingSummary, setLoadingSummary] = useState(false);

  const { handleResetAllDemo, loadingResetAll } = useBotDemo();
  return (
    <div className="rounded-t-xl border-b border-solid border-[#DDE1E6] bg-[linear-gradient(60deg,rgba(234,221,255,0)_62.74%,#8962FF_254.21%)] p-3 ">
      <div
        onClick={handleResetAllDemo}
        className="flex items-center gap-2 justify-end mb-2 text-[#8C1D18] cursor-pointer"
      >
        {loadingResetAll ? "Resetting..." : "Reset Capital"}
        <ArrowPathIcon
          className={`w-4 h-4 text-[#8C1D18] ${
            loadingResetAll ? "animate-spin" : ""
          }`}
        />
      </div>
      {/* <div className="flex justify-between">
        <div>
          <span className="text-xs text-[#999]">Current Value</span>
          <div className="text-base font-bold text-[#523C72]">
            {loadingSummary ? (
              <SkeletonCard
                type="text"
                lines={1}
                widths={["100px"]}
                heights={["15px"]}
              />
            ) : (
              `0 USDT`
            )}
          </div>
        </div>
        <div>
          <span className="text-xs text-[#999]">Realized P/L</span>
          <div>
            <span>
              {loadingSummary ? (
                <SkeletonCard
                  type="text"
                  lines={2}
                  widths={["60px", "40px"]}
                  heights={["15px", "10px"]}
                />
              ) : (
                `0 USDT`
              )}
            </span>
            <span
              className={`block text-xs ${
                true ? "text-[#1E8610]" : "text-[#FF3B30]"
              } font-normal`}
            >
              {loadingSummary ? null : `0 %`}
            </span>
          </div>
        </div>
        <div>
          <span className="text-xs text-[#999]">Unrealized P/L</span>
          <div>
            <span>
              {loadingSummary ? (
                <SkeletonCard
                  type="text"
                  lines={1}
                  widths={["60px", "40px"]}
                  heights={["15px", "10px"]}
                />
              ) : (
                `0 USDT`
              )}
            </span>
            <span
              className={`block text-xs ${
                true ? "text-[#1E8610]" : "text-[#FF3B30]"
              } font-normal`}
            >
              {loadingSummary ? null : `0 %`}
            </span>
          </div>
        </div>
      </div> */}
    </div>
  );
}
